//物资供应链

import { base, baseGateway } from "./base"; // 导入接口域名列表
import axios from "@/utils/http"; // 导入http中创建的axios实例

const twice = {
  // 采购组织 查询企业列表
  getTypsStatementCompanyList(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/companyList`
    );
  },
  // 送货单------------------------------
  // 分页查询送货单
  postBcscArrivalBillPage(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/page`,
      params
    );
  },
  // 送货单废止
  storageArrivalBillCancel(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/storageArrivalBillCancel`,
      params
    );
  },
  // 详情
  getBcscArrivalBillDetail(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/detail?arrivalBillNo=${
        params.id
      }`
    );
  },
  //查询合同详情里的送货单明细
  postBcscArrivalBillContractDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/contractDetail`,
      params
    );
  },
  //保存送货单
  postBcscArrivalBillContractSave(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/save`,
      params
    );
  },
  //送货单编辑
  postBcscArrivalBillContractEdit(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/edit`,
      params
    );
  },
  // 打印送货单
  getBcscArrivalBillPrint(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/print?arrivalBillNo=${params}`
    );
  },
  // 查询派车送货数量
  getBcscArrivalBillQueryTransAmount(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/queryTransAmount?supplyCode=${params}`
    );
  },
  // 送货单删除--作废
  getBcscArrivalBillCancel(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/cancel?arrivalBillNo=${params}`
    );
  },
  // 结算单----------------------------------------------------------------
  //发票列表
  postTypsStatementInvoiceList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/invoiceList`,
      params
    );
  },
  //发票结算数量 --
  postTypsStatementQueryQuantity(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/queryQuantity`,
      params
    );
  },
  //采购发票暂存 --
  postTypsStatementSaveInvocie(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/saveInvocie`,
      params
    );
  },
  // 物资供应商发票上传接口
  postTypsStatementFileUpload(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/file/upload`,
      params
    );
  },
  //可生成发票列表 --
  postTypsStatementQueryStayWriteOffSettlementPage(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/queryStayWriteOffSettlementPage`,
      params
    );
  },
  // 发票类型
  getTypsStatementInvoiceType(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/invoiceType?dictCode=${params}`
    );
  },

  //发票详情---发票信息回显
  postTypsStatementInvoiceDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/invoiceDetail`,
      params
    );
  },
  //删除发票 --
  postTypsStatementDeleteInvoice(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/deleteInvoice`,
      params
    );
  },
  // 物资供应商附件下载接口
  // postTypsStatementFileDownload(params) {
  //   return axios.post(`${baseGateway()}/chem-gateway/chem-ctm/typsStatement/file/download`, params);
  // },
  //删除结算明细
  postTypsStatementDeleteSettlementDetails(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/deleteSettlementDetails`,
      params
    );
  },
  // 银行列表
  getTypsStatementBankList() {
    // return axios.post(
    //   `${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/query-company-bank`,
    //   { orgId: orgId }
    // );
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsStatement/bankList`
    );
  },

  // 客商物质采购询单列表--------------------------------------------------------------------------------------------
  // 客商物质采购询单列表
  postInquiryTypsTable(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-rfq/inquiry/typs/table`,
      params
    );
  },
  // 客商物资采购询单数量统计
  getInquiryTypsMyInquiryNum() {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-rfq/inquiry/typs/myInquiryNum`
    );
  },
  // 送货计划-----------------------------------------------------------------------------------------------------------
  // 送货计划分页查询
  postTypsContractDeliveryScheduleList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/deliveryScheduleList`,
      params
    );
  },
  // 送货计划行分页查询(创建送货单时选择送货计划)
  postTypsContractDeliveryScheduleDetailList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/deliveryScheduleDetailList`,
      params
    );
  },
  // 送货计划代办数量
  getTypsContractDeliveryScheduleTodoCount(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/deliveryScheduleTodoCount?supplyUnitCode=${params}`
    );
  },
  // 送货计划详情
  postTypsContractDeliveryScheduleDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/deliveryScheduleDetail`,
      params
    );
  },
  // 删除送货计划
  postTypsContractDeleteDeliverySchedule(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/deleteDeliverySchedule`,
      params
    );
  },
  // 废除送货计划
  contractDeliveryScheduleDelete(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/contractDeliveryScheduleDelete`,
      params
    );
  },
  // 送货计划保存-修改
  postTypsContractSaveOrUpdateDeliverySchedule(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/saveOrUpdateDeliverySchedule`,
      params
    );
  },
  // 送货计划提交审核
  postTypsContractCommitDeliverySchedule(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/commitDeliverySchedule`,
      params
    );
  },
  //合同分页---------------------------------------------------------------------------------------------------------
  //合同分页列表
  postTypsContractContractList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/contractList`,
      params
    );
  },
  // 查询合同详细信息
  postTypsContractContractDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/contractDetail`,
      params
    );
  },
  // 查询合同详情里的送货单明细
  postArrivalBillContractDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/contractDetail`,
      params
    );
  },

  //查询合同签署和变更信息 contractCode
  getCustomContractTestSelectSignOrChangeInfo(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/customContractTest/selectSignOrChangeInfo/${params}`
    );
  },

  //待签署合同数量
  getTypsContractQueryContractQuantity(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/queryContractQuantity?supplyUnitCode=${params}`
    );
  },
  //查询仓库信息及对应的库位信息
  getTypsContractStorageWarehouse(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/storageWarehouse?accountSet=${params}`
    );
  },
  // 订单行信息-------------------------------------------------------------------------------------------------------
  //分页获取订单行信息-分页查询可使用订单行信息
  postTypsContractOrderDetailList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/orderDetailList`,
      params
    );
  },
  //分页获取订单行信息-分页查询可使用订单行信息
  postTypsContractOrderList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/orderList`,
      params
    );
  },
  //打印订单
  getTypsPrintOrder(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/bcsc/arrivalBill/printOrder?orderNo=${params}`
    );
  },
  // /chem-ctm/typsContract/orderList
  //可执行订单行数量
  getTypsContractOrderDetailToDoCount(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/orderDetailToDoCount?supplyUnitCode=${params}`
    );
  },
  //订单接单/拒单
  getTypsContractOrderDetailOrderBack(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/orderBack`,
      params
    );
  },
  //获取订单详情
  getTypsContractOrderDetail(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/detailByOrderNo?orderNo=${params}`
    );
  },
  // 获取订单详情信息
  getTypsContractOrderDetailInfo(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/typsContract/orderDetail?orderNo=${params}`
    );
  },
};
export default twice;
